import script from "./Switch.vue?vue&type=script&setup=true&lang=js"
export * from "./Switch.vue?vue&type=script&setup=true&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=508aee26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508aee26"]])

export default __exports__